import { client } from './client'

export const publishX = (x: number) => {
  client.post('data/publish/3oom/rpi', { data: { x: x } })
  console.log(x)
}
